module.exports = __webpack_public_path__ + "img/golf-academy-logo.279210e8.png";